export const BASE_URL = "https://api.whatuwant.ai/api";
export const QFLOW_BASE_URL = "https://chat.whatuwant.ai";
export const SOCKET_URL = "https://socket.whatuwant.ai";
